import { FileText } from "@phosphor-icons/react";

export default function AnalysisDetail({ session }) {
  const drawings = session.drawings || [];
  return (
    <div className="p-4 space-y-4">
      <p className="text-sm text-slate-600">
        Free-form analysis session with {drawings.length} drawing{drawings.length !== 1 ? "s" : ""}.
      </p>
      {drawings.length > 0 && (
        <div>
          <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Drawings</h3>
          <div className="space-y-1.5">
            {drawings.map((d, i) => (
              <div key={d.slot} className="flex items-center gap-2 text-xs text-slate-600 bg-slate-50 rounded px-3 py-2">
                <FileText size={12} className="text-slate-400 flex-shrink-0" />
                <span className="font-medium">Drawing {i}:</span>
                <span className="truncate">{d.filename}</span>
                <span className="text-slate-400 flex-shrink-0">({d.page_count}p)</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
